import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    powerFlowDirection: Port.powerFlowDirection.literals.input,
}).default({});

const LightBase = z.object({
    type: z.literal('light').default('light'),
    electrical: z
        .object({
            ports: z.tuple([port]).default([undefined]),
        })
        .default({}),
});

export const LightValidator = ComponentValidator.merge(LightBase);
export const LightPayloadValidator = ComponentPayloadValidator.merge(LightBase);

export const LightDefinition: ComponentDefinition = {
    type: 'light',
    name: 'Light',
    plural: 'Lights',
    indicator: 'LIGHT',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: true,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['input'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: LightValidator,
        payload: LightPayloadValidator,
    },
};

export type Light = z.infer<typeof LightValidator>;
export type LightPayload = z.infer<typeof LightPayloadValidator>;
